import { render, staticRenderFns } from "./ContentCardsPlans.vue?vue&type=template&id=5bfb37d6"
import script from "./ContentCardsPlans.vue?vue&type=script&lang=js"
export * from "./ContentCardsPlans.vue?vue&type=script&lang=js"
import style0 from "./ContentCardsPlans.vue?vue&type=style&index=0&id=5bfb37d6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bfb37d6')) {
      api.createRecord('5bfb37d6', component.options)
    } else {
      api.reload('5bfb37d6', component.options)
    }
    module.hot.accept("./ContentCardsPlans.vue?vue&type=template&id=5bfb37d6", function () {
      api.rerender('5bfb37d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/payment/details/components/ContentCardsPlans.vue"
export default component.exports